import EchionE from "../assets/skills/echion/Echion_E.png";
import EchionPBlackMamba from "../assets/skills/echion/Echion_P_BlackMamba.png";
import EchionPDeathAdder from "../assets/skills/echion/Echion_P_DeathAdder.png";
import EchionPSidewinder from "../assets/skills/echion/Echion_P_Sidewinder.png";
import EchionQ from "../assets/skills/echion/Echion_Q.png";
import EchionQ2 from "../assets/skills/echion/Echion_Q2.png";
import EchionRBlackMamba from "../assets/skills/echion/Echion_R_BlackMamba.png";
import EchionRDeathAdder from "../assets/skills/echion/Echion_R_DeathAdder.png";
import EchionRSidewinder from "../assets/skills/echion/Echion_R_Sidewinder.png";
import EchionW from "../assets/skills/echion/Echion_W.png";

export const ECHION_SKILL_IMAGES = {
  Q: EchionQ,
  Q2: EchionQ2,
  W: EchionW,
  E: EchionE,
  passive: {
    deathadder: EchionPDeathAdder,
    sidewinder: EchionPSidewinder,
    blackmamba: EchionPBlackMamba,
  },
  R: {
    deathadder: EchionRDeathAdder,
    sidewinder: EchionRSidewinder,
    blackmamba: EchionRBlackMamba,
  },
};
